// css variable which would store current Stage scale
export const CSS_VARIABLE_STAGE_SCALE = '--stage-scale';

// css variable which would store visible scale (the scale - so that Nodes visible dimension doesn't change on zoom)
export const CSS_VARIABLE_STAGE_VISIBLE_SCALE = '--stage-visible-scale';

// css variable which would store current Stage rotation
export const CSS_VARIABLE_STAGE_ROTATION = '--stage-rotation';

// css variable which would store visible stroke width based on scale
export const CSS_VARIABLE_STAGE_STROKE_WIDTH = '--stage-stroke-width';
export const CSS_VARIABLE_HOVERED_STAGE_STROKE_WIDTH = '--stage-hovered-stroke-width';